
import { t } from "@/plugins/i18n";
export default interface AccStatus {
  name: string;
  readOnly: boolean;
  deleted: boolean;
  id: number;
}

export const accStatusDefaultProps: AccStatus = {
  name: t("Osszes"),
  readOnly: true,
  deleted: false,
  id: 1,
};
